import { reactive } from 'vue';

export interface LocalPlayerState {
  playerId: number | undefined;
  entityId: number | undefined;
  serverEntityId: number | undefined;
}

/**
 * Client-only service for local player identity.
 */
export class LocalPlayerService {
  private state: LocalPlayerState;

  constructor() {
    this.state = reactive({
      playerId: undefined,
      entityId: undefined,
      serverEntityId: undefined,
    });
  }

  public get playerId(): number | undefined {
    return this.state.playerId;
  }

  public set playerId(value: number | undefined) {
    this.state.playerId = value;
  }

  public get entityId(): number | undefined {
    return this.state.entityId;
  }

  public set entityId(value: number | undefined) {
    this.state.entityId = value;
  }

  public get serverEntityId(): number | undefined {
    return this.state.serverEntityId;
  }

  public set serverEntityId(value: number | undefined) {
    this.state.serverEntityId = value;
  }

  /**
   * Check if the local player is fully initialized.
   */
  public isInitialized(): boolean {
    return this.state.playerId !== undefined && this.state.entityId !== undefined;
  }

  /**
   * Reset the service (for testing or reconnection).
   */
  public reset(): void {
    this.state.entityId = undefined;
    this.state.serverEntityId = undefined;
  }

  public handleWhoAmI(
    payload: { playerId: number; entityId: number },
    clientEntityId: number | undefined,
  ): void {
    this.state.playerId = payload.playerId;
    this.state.serverEntityId = payload.entityId;
    this.state.entityId = clientEntityId;
    localStorage.setItem('playerId', payload.playerId.toString());
  }
}
